import * as React from "react";
import CurrencyHelper from "../../../../helper/CurrencyHelper";

interface IProps {
	value: number;
}

export const CurrencyPresenter: React.SFC<IProps> = (props) => {
	return (
		<span>{CurrencyHelper.toCurrency(props.value)}</span>
	);
};
